// Action for updating local/redux gateway settings data
import { GatewaySettingsFormValues } from "./types"

export const UPDATE_GATEWAY_SETTINGS = "UPDATE_GATEWAY_SETTINGS"
export const updateGatewaySettings = (data: GatewaySettingsFormValues, locationId: string) => ({
    type: UPDATE_GATEWAY_SETTINGS,
    payload: {
        locationId: locationId,
        data: data,
    },
})
